import _ from 'lodash';

export default (multibookType) => {
  let subconfig = { showBookIndexIcon: true, bookColorTheme: undefined };
  try {
    subconfig = require(`__staticDir/${multibookType}/config/subconfig`)?.default;
  } catch (error) {
    subconfig = { showBookIndexIcon: true, bookColorTheme: undefined };
  }

  const pagesData = require(`__staticDir/${multibookType}/config`)?.default;

  let pages = _.chain(pagesData)
    .map((page) => {
      if (page.right && page.right.games) {
        page.right.games = page.right.games.map((game) => {
          if (game.item && game.item.gamePath) {
            game.item.gamePath = game.item.gamePath.replace('static/', `static/${multibookType}/`);
          } else if (game.items) {
            game.items = game.items.map((o) => {
              if (o.item && o.item.gamePath) {
                o.item.gamePath = o.item.gamePath.replace('static/', `static/${multibookType}/`);
              }
              return o;
            });
          }
          return game;
        });
      }
      if (page.left && page.left.games) {
        page.left.games = page.left.games.map((game) => {
          if (game.item && game.item.gamePath) {
            game.item.gamePath = game.item.gamePath.replace('static/', `static/${multibookType}/`);
          } else if (game.items) {
            game.items = game.items.map((o) => {
              if (o.item && o.item.gamePath) {
                o.item.gamePath = o.item.gamePath.replace('static/', `static/${multibookType}/`);
              }
              return o;
            });
          }
          return game;
        });
      }
      return page;
    })
    .value();

  let cover = _.compact(
    _.map(pages, (page) => {
      if (page.start) {
        return page;
      } else if (page.stop) {
        return page;
      }
      return false;
    })
  );

  let games = new Map();
  let processPages = _.chain(pages)
    .map((page) => {
      let data = [];
      if (page.right) {
        data = [...data, ...page.right.games];
      }
      if (page.left) {
        data = [...data, ...page.left.games];
      }
      return data;
    })
    .flatMap((game) => {
      return game;
    })
    .map((item) => {
      return games.set(`${item.id}`, item);
    })
    .value();

  let presentations = new Map();
  let processPresetations = _.chain(pages)
    .map((page) => {
      let data = [];
      if (page.right) {
        data = [...data, ...page.right.presentation];
      }
      if (page.left) {
        data = [...data, ...page.left.presentation];
      }
      return data;
    })
    .flatMap((game) => {
      return game;
    })
    .reduce((acc, item) => {
      return acc.set(`${item.id}`, item);
    }, presentations)
    .value();

  const actualPage = pages[0];

  // console.log('pages', pages);
  let songs = new Map();
  let processSongs = _.chain(pages)
    .map((page) => {
      let data = [];
      if (page.right) {
        data = [...data, ...page.right.karaoke];
      }
      if (page.left) {
        data = [...data, ...page.left.karaoke];
      }
      return data;
    })
    .flatMap((game) => {
      return game;
    })
    .reduce((acc, item) => {
      return acc.set(`${item.id}`, item);
    }, songs)
    .value();

  const state = {
    actualPage,
    pages,
    games,
    songs,
    presentations,
    /**
     *  disable icon in multibook
     */
    showBookIndexIcon: subconfig?.showBookIndexIcon ? true : false,
    bookColorTheme: subconfig?.bookColorTheme ? subconfig.bookColorTheme : undefined,
  };

  const mutations = {
    FIRST_PAGE(state) {
      state.actualPage = state.pages[0];
    },
    PREVIUS_PAGE(state) {
      let test = _.findIndex(state.pages, function (o) {
        return o.id === state.actualPage.id;
      });
      if (test >= 1) {
        state.actualPage = state.pages[test - 1];
      }
    },
    NEXT_PAGE(state) {
      if (process.NODE_PERFORMANCE) {
        var t0 = performance.now();
      }
      let test = _.findIndex(state.pages, function (o) {
        return o.id === state.actualPage.id;
      });
      if (test < state.pages.length - cover.length + 1) {
        state.actualPage = state.pages[test + 1];
      }
      if (process.NODE_PERFORMANCE) {
        var t1 = performance.now();
        console.log('Vuex Call NEXT_PAGE took ' + (t1 - t0) + ' milliseconds.');
      }
    },
    LAST_PAGE(state) {
      state.actualPage = state.pages[state.pages.length - 1];
    },
    CHANGE_ACTUAL_PAGE(state, id) {
      state.actualPage = state.pages[parseInt(id)];
    },
  };

  const actions = {
    someAsyncTask({ commit }) {
      // do something async
      commit('CHANGE_ACTUAL_PAGE');
    },
  };
  const getters = {
    getActualPage: (state) => {
      let page = {};
      if (state.actualPage) {
        if (state.actualPage.left) {
          page.left = {
            id: state.actualPage.left.id,
            imageSrc: state.actualPage.left.imageSrc,
            gallery: state.actualPage.left.gallery,
            film: state.actualPage.left.film,
            audio: state.actualPage.left.audio,
            interactive: state.actualPage.left.interactive,
            images: state.actualPage.left.images,
            games: state.actualPage.left.games,
            scratch: state.actualPage.left.scratch,
            presentation: state.actualPage.left.presentation,
            rectangle: state.actualPage.left.rectangle,
          };
        }
        if (state.actualPage.right) {
          page.right = {
            id: state.actualPage.right.id,
            imageSrc: state.actualPage.right.imageSrc,
            gallery: state.actualPage.right.gallery,
            film: state.actualPage.right.film,
            audio: state.actualPage.right.audio,
            interactive: state.actualPage.right.interactive,
            images: state.actualPage.right.images,
            games: state.actualPage.right.games,
            presentation: state.actualPage.right.presentation,
            scratch: state.actualPage.right.scratch,
            rectangle: state.actualPage.right.rectangle,
          };
        }
        page.start = state.actualPage.start;
        page.stop = state.actualPage.stop;
        page.id = state.actualPage.id;
        if (page.right && page.right.images) {
          _.each(page.right.images, (image) => {
            let temp = {};
            temp[image.id] = false;
            state.modalImages = _.extend(state.modalImages, temp);
          });
        }
        if (page.left && page.left.images) {
          _.each(page.left.images, (image) => {
            let temp = {};
            temp[image.id] = false;
            state.modalImages = _.extend(state.modalImages, temp);
          });
        }
        return page;
      }
      return state.actualPage;
    },
    getActualPageIndex: (state) => {
      if (state.actualPage) {
        return state.actualPage.id;
      }
      return;
    },
    pageLength: (state) => {
      return state.pages.length;
    },
    getAllPages: (state) => {
      return state.pages;
    },
    getPages: (state) => {
      let initial = _.initial(state.pages);

      let pages = _.tail(initial);
      return pages;
    },
    getPageById: (state) => (id) => {
      return state.pages.find((page) => {
        return page.id === id;
      });
    },
    getDoublePageNumbersText: (state, getters) => {
      if (state.actualPage) {
        if (getters.getActualPage.start) {
          return ' ';
        }
        if (getters.getActualPage.stop) {
          return ' ';
        } else {
          return [getters.getActualPage.left.id, getters.getActualPage.right.id].join(' – ');
        }
      }
      return;
    },
    prevExist: (state, getters) => {
      if (getters.getActualPageIndex !== 0 && state.pages[getters.getActualPageIndex - 1]) {
        return !!state.pages[getters.getActualPageIndex - 1];
      }
      return false;
    },
    nextExist: (state, getters) => {
      if (getters.getActualPageIndex !== state.pages.length && state.pages[getters.getActualPageIndex + 1]) {
        return !!state.pages[getters.getActualPageIndex + 1];
      }
      return false;
    },
    getFirstPageIndex: (state) => {
      if (state.actualPage) {
        return state.pages[0].id;
      }
      return;
    },
    getLastPageIndex: (state) => {
      if (state.actualPage) {
        return state.pages[state.pages.length - 1].id;
      }
      return;
    },
    getPreviusIndex: (state, getters) => {
      return getters.getActualPageIndex - 1 >= 0 ? getters.getActualPageIndex - 1 : getters.getActualPageIndex;
    },
    getNextIndex: (state, getters) => {
      return getters.getActualPageIndex + 1 <= state.pages.length - 1
        ? getters.getActualPageIndex + 1
        : getters.getActualPageIndex;
    },
    games: (state) => {
      return state.games;
    },
    gameByID: (state) => {
      return (id) => {
        return state.games.get(`${id}`);
      };
    },

    presentations: (state) => {
      return state.presentations;
    },
    presentationByID: (state) => {
      return (id) => {
        // console.log('id', id);
        // console.log('state.presentations.get(`${id}`)', state.presentations.get(`${id}`));
        return state.presentations.get(`${id}`);
      };
    },
    songs: (state) => {
      return state.songs;
    },
    showBookIndexIcon: (state) => {
      return state.showBookIndexIcon;
    },
    getBookColorTheme: (state) => {
      return state.bookColorTheme;
    },
  };
  return { namespaced: true, state, getters, mutations, actions };
};
